import { Component, Input, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Store } from '@ngrx/store';
import { Cookies } from 'src/app/lib/cookies';
import isEmpty from 'src/app/lib/isEmpty';
import { toFixedDown } from 'src/app/lib/roundOf';
import { TradePairFacade } from 'src/app/store/bottradepair';
import { PositionDetailsFacade } from 'src/app/store/positionDetails';
import { UserSettingFacade } from 'src/app/store/usersetting';

import { IChartingLibraryWidget, widget } from 'src/assets/charting_library/charting_library.min';
import { environment } from 'src/environments/environment';

const chartUrl = environment.spotApiUrl; // 'https://credspotapi.wearedev.team/' 

// 👇 Wrapper inside this file
class CustomDatafeed extends (window as any).Datafeeds.UDFCompatibleDatafeed {
  decimals: number;

  constructor(url: string, decimals: number) {
    super(url);
    this.decimals = decimals;
  }

  resolveSymbol(symbolName: any, onSymbolResolvedCallback: any, onResolveErrorCallback: any) {
    super.resolveSymbol(
      symbolName,
      (symbolInfo: any) => {
        // Force precision
        symbolInfo.pricescale = Math.pow(10, this.decimals); // e.g. 100000 for 5 decimals
        symbolInfo.minmov = 1; // smallest price movement
        symbolInfo.ticker = symbolName;

        // 👇 also important: precision
        symbolInfo.format = "price";
        symbolInfo.description = symbolInfo.description || symbolName;
        symbolInfo.session = symbolInfo.session || "24x7";
        symbolInfo.supported_resolutions = symbolInfo.supported_resolutions || ["1", "5", "15", "60", "240", "1D", "1W"];

        console.log("Resolved symbolInfo (patched):", symbolInfo);
        onSymbolResolvedCallback(symbolInfo);
      },
      onResolveErrorCallback
    );
  }

}

@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.css']
})
export class ChartComponent {
  @Input() chartData: any

  theme: 'Dark' | 'Light' = 'Dark'
  pairData: any = {}
  secondFloatDigit: any = 8
  public isMobileLayout = false;
  public isDestopLayout = false;

  backUrl = chartUrl + 'api/spot/chart';
  pair = "BNBUSDT";
  first_time = true
  private _tvWidget: IChartingLibraryWidget | null = null;

  posDetails: any = {}
  constructor(
    private location: Location,
    private tradePairFacade: TradePairFacade,
    private userSettingFacade: UserSettingFacade,
    private cookies: Cookies,
    private store: Store<{ positionDetails: PositionDetailsFacade }>
  ) { }

  ngOnInit() {
    window.onresize = () => this.isMobileLayout = window.innerWidth <= 1199;
    window.onload = () => this.isMobileLayout = window.innerWidth <= 1199;
    this.getThemeData(this.chartData)
    this.store.select('positionDetails').subscribe((posDet: any) => {
      this.posDetails = posDet.positionDetails;
    });
    console.log(this.chartData, '--------49')
  }

  ngOnChanges(changes: SimpleChanges): void {
    // alert()
    // if (changes['testVar']) {
    //   console.log('testVartestVartestVar2', changes['testVar'].currentValue);
    // }

    if (changes['chartData'] && !changes['chartData'].firstChange) {
      console.log(changes['chartData'], changes['chartData'].firstChange, "SFD0sd0s0f")
      this.getThemeData(this.chartData)
    }
  }

  getThemeData(cData: any) {
    this.userSettingFacade.usersetting$.subscribe({
      next: (data: any) => {
        if (data.defaultTheme) {
          this.theme = data.defaultTheme === 'dark' ? 'Dark' : 'Light'
          this.getTradeData(cData)
        }
      },
      error: (err: any) => { }
    })
  }

  getTradeData(cData: any) {
    this.tradePairFacade.tradePair$.subscribe({
      next: (tradePair: any) => {
        if (!isEmpty(tradePair)) {
          let symbol = tradePair.firstCurrencySymbol + tradePair.secondCurrencySymbol;
          this.secondFloatDigit = tradePair?.secondFloatDigit ?? 8
          this.buildChart(symbol, cData)
        }
      },
      error: (err: any) => { }
    })
  }

  buildChart(pair: string, cData: any) {
    const decimals = this.secondFloatDigit;
    let userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone || "Asia/Kolkata";
    if (userTimezone === "Asia/Calcutta") {
      userTimezone = "Asia/Kolkata";
    }
    const widgetOptions: any = {
      symbol: pair,
      datafeed: new CustomDatafeed(this.backUrl, decimals), // 👈 patched datafeed
      interval: '60',
      container_id: 'tv_chart_container3',
      library_path: '/assets/charting_library/',
      locale: 'en',
      disabled_features: ["use_localstorage_for_settings", "display_market_status"],
      enabled_features: ["study_templates", "hide_left_toolbar_by_default"],
      charts_storage_url: "",
      charts_storage_api_version: "1.1",
      client_id: "tradingview.com",
      user_id: "public_user_id",
      fullscreen: false,
      autosize: false,
      studies_overrides: {},
      loading_screen: { backgroundColor: "#121212" },
      theme: this.theme,
      toolbar_bg: "#121212",
      timezone: userTimezone,
      overrides: {
        // Background colors to match your app
        "paneProperties.background": "#161a1e",
        "paneProperties.vertGridProperties.color": "#2a2e39", // Subtle grid lines
        "paneProperties.horzGridProperties.color": "#2a2e39",

        // X-Axis (Time) Styling
        "scalesProperties.textColor": "#9ca3af", // Grey text like Binance
        "timeScale.rightOffset": 5,              // Small gap at the end

        // Candles
        "mainSeriesProperties.candleStyle.upColor": "#0ECB81",   // Binance Green
        "mainSeriesProperties.candleStyle.downColor": "#F6465D", // Binance Red
        "mainSeriesProperties.candleStyle.borderUpColor": "#0ECB81",
        "mainSeriesProperties.candleStyle.borderDownColor": "#F6465D",
        "mainSeriesProperties.candleStyle.wickUpColor": "#0ECB81",
        "mainSeriesProperties.candleStyle.wickDownColor": "#F6465D",
      },
      custom_formatters: {
        timeFormatter: {
          format: (date: Date) => {
            const _format_0 = (number: number) => number.toString().padStart(2, '0');
            return `${_format_0(date.getHours())}:${_format_0(date.getMinutes())}`;
          }
        },
        dateFormatter: {
          format: (date: Date) => {
            return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
          }
        }
      }
    };

    if (this.theme == 'Light') {
      delete widgetOptions.toolbar_bg;
      delete widgetOptions.overrides;
    }

    const tvWidget = new widget(widgetOptions);
    tvWidget.onChartReady(() => {
      tvWidget.headerReady().then(() => {
        const button = tvWidget.createButton();
        button.setAttribute("title", "Click to show a notification popup");
        button.classList.add("apply-common-tooltip");
        button.addEventListener("click", () =>
          tvWidget.showNoticeDialog({
            title: "Notification",
            body: "TradingView Charting Library API works correctly",
            callback: () => { },
          })
        );
        console.log(cData, '-------123', cData?.stoploss && cData?.stoploss?.percentage > 0 &&
          cData?.stoploss?.price > 0)

        console.log("---237", cData?.avgPrice, typeof cData?.avgPrice?.avgPrice)



        if (
          !isEmpty(cData) &&
          cData?.takeprofit?.price > 0
        ) {
          console.log('------128')
          let priceScale_Reset: any = tvWidget
            .activeChart()
            .getPanes()[0]
            .getMainSourcePriceScale();
          console.log(priceScale_Reset, '-----133')
          // priceScale_Reset.applyOptions({
          //   autoScale: true
          // });
          console.log('--------134')
          let avgprice = cData?.avgPrice.avgPrice;
          let lp;
          if (
            cData &&
            cData.stoploss &&
            cData.stoploss?.percentage > 0 &&
            cData.stoploss?.price > 0
          ) {
            lp = cData.stoploss.price;
          } else {
            if (
              cData &&
              cData?.avgCall &&
              cData?.avgCall.length > 0 &&
              cData?.avgCall[cData.avgCall?.length - 1].price
            ) {
              lp = cData.avgCall[cData.avgCall.length - 1].price;
            } else {
              lp = cData?.markPrice;
            }
          }
          let hp;
          if (parseFloat(cData.takeprofit.price) < parseFloat(cData?.markPrice)) {
            hp = cData?.markPrice;
          } else {
            hp = cData.takeprofit && cData.takeprofit.price;
          }
          hp = parseFloat(hp);
          lp = parseFloat(lp);
          console.log(lp, "-----lp");
          console.log(hp, "-----hp");
          if (lp > 0 && hp > 0) {
            let priceScale = tvWidget
              .activeChart()
              .getPanes()[0]
              .getRightPriceScales()[0];
            let a = priceScale.setVisiblePriceRange({
              from: toFixedDown(lp - (lp * 2) / 100, cData?.priceDecimal),
              to: toFixedDown(hp + (hp * 2) / 100, cData?.priceDecimal),
            });
          }
        }
        if (cData?.takeprofit?.price > 0) {
          console.log('------125')
          // Create an order line at the price of 95,000
          const chart = tvWidget.activeChart();
          const orderLine = chart.createOrderLine({});
          // Set the price using setPrice method
          orderLine.setPrice(cData.takeprofit.price);  // Set static price for the order line

          // Customize the order line
          orderLine.setLineStyle(0);  // 0 = solid, 1 = dotted, 2 = dashed, etc.
          orderLine.setLineLength(25); // Length of the order line (optional)
          orderLine.setBodyFont(`Order Line - ${cData.takeprofit.price}`); // Text to display on the order line
          orderLine.setQuantity(toFixedDown(cData.takeprofit.amount, 2)); // Quantity or other info (optional)
          orderLine.setBodyTextColor('#FF0000'); // Set text color
          orderLine.setLineColor('#FF0000'); // Set line color
          orderLine.setText(`TakeProfit - ${toFixedDown(cData.takeprofit.price)}`); // Replace "Order" with custom label
        }
        if (cData?.avgPrice && cData?.avgPrice?.avgPrice > 0) {
          // Create an order line at the price of 95,000
          const chart = tvWidget.activeChart();
          const orderLine = chart.createOrderLine({});
          // Set the price using setPrice method
          orderLine.setPrice(cData.avgPrice.avgPrice);  // Set static price for the order line

          // Customize the order line
          orderLine.setLineStyle(0);  // 0 = solid, 1 = dotted, 2 = dashed, etc.
          orderLine.setLineLength(25); // Length of the order line (optional)
          orderLine.setText("DCA"); // Replace "Order" with custom label
          // orderLine.setBodyFont(`Order Line - ${ cData.avgPrice.price } `); // Text to display on the order line
          orderLine.setQuantity(toFixedDown(cData.avgPrice.amount, 2)); // Quantity or other info (optional)
          // orderLine.setTextColor('#FF0000'); // Set text color
          orderLine.setLineColor('rgb(22, 112, 72)'); // Set line color
        }


        if (cData?.avgCall && cData.avgCall.length > 0) {
          for (let i = 0; i < cData.avgCall.length; i++) {
            let item = cData.avgCall[i]
            // Create an order line at the price of 95,000
            const chart = tvWidget.activeChart();
            const orderLine = chart.createOrderLine({});
            // Set the price using setPrice method
            orderLine.setPrice(item.price);  // Set static price for the order line

            // Customize the order line
            orderLine.setLineStyle(0);  // 0 = solid, 1 = dotted, 2 = dashed, etc.
            orderLine.setLineLength(25); // Length of the order line (optional)
            orderLine.setBodyFont(`Order Line - ${item.price}`); // Text to display on the order line
            orderLine.setText(`Averaging Call(${item.cntstart + i + 1}) - ${toFixedDown(item.price)} `); // Replace "Order" with custom label
            orderLine.setBodyTextColor('rgb(22, 112, 72)'); // Set text color
            orderLine.setLineColor('rgb(22, 112, 72)'); // Set line color
            orderLine.setQuantity(""); // Quantity or other info (optional)

          }
        }




        // grid chart
        if (cData?.stoploss && cData?.stoploss?.percentage > 0 &&
          cData?.stoploss?.price > 0 && cData?.avgCall?.length == 0) {
          // Create an order line at the price of 95,000
          const chart = tvWidget.activeChart();
          const orderLine = chart.createOrderLine({});
          // Set the price using setPrice method
          orderLine.setPrice(cData.stoploss.price);  // Set static price for the order line

          // Customize the order line
          orderLine.setLineStyle(0);  // 0 = solid, 1 = dotted, 2 = dashed, etc.
          orderLine.setLineLength(25); // Length of the order line (optional)
          orderLine.setText(`StopLoss`);
          // orderLine.setBodyFont(`Order Line - ${ cData.takeprofit.price } `); // Text to display on the order line
          orderLine.setQuantity(toFixedDown(cData.stoploss.amount, 2)); // Quantity or other info (optional)
          // orderLine.setTextColor('#FF0000'); // Set text color
          orderLine.setLineColor('rgb(200, 7, 7)'); // Set line color
          orderLine.setBodyTextColor('rgb(200, 7, 7)'); // Set text color
        }

        if (cData?.botType == "grid" && cData?.data?.length > 0) {
          for (const order of cData?.data) {
            const { price, quantity, side } = order
            const { postRound } = order?.positionId
            const chart = tvWidget.activeChart();
            chart.setResolution('60', () => {
              console.log('Chart interval set to 1 hour (60m)');
              // You can safely perform further chart actions here
            });
            const orderLine = chart.createOrderLine({});
            if (price)
              orderLine.setPrice(price);

            orderLine.setLineStyle(2);  // 0 = solid, 1 = dotted, 2 = dashed, etc.
            orderLine.setLineLength(100);
            orderLine.setText(`Round ${postRound ? postRound : "1"}`);
            orderLine.setLineColor(`${side == "sell" ? "rgb(200, 7, 7)" : "rgb(22, 112, 72)"}`); // Set line color
            orderLine.setBodyTextColor(`${side == "sell" ? "rgb(200, 7, 7)" : "rgb(22, 112, 72)"}`); // Set text color
            if (quantity)
              orderLine.setQuantity(toFixedDown(quantity, 4)); // Quantity or other info (optional)
          }

        }


        // admin bot
        const currentPath = this.location.path(); // e.g. "/adminBot/BTCUSDT"
        const activePair = currentPath.split('/')?.[1]; // Assuming path is "/adminBot/:pair"
        if (activePair == "adminBot" || activePair == "adminBotDownside" || activePair == "adminTradeUpsideHanuman" || activePair == "adminTradeBotGuru" || activePair == "hanumanBot") {
          const chart = tvWidget.activeChart();
          chart.setResolution('5', () => {
            console.log('Chart interval set to 1 hour (60m)');
            // You can safely perform further chart actions here
          });
          // --- Bollinger Bands ---
          // Inputs: [Length (20), StdDev (2)]
          chart.createStudy('Bollinger Bands', false, false, [20, 2], {

            // --- MIDDLE BAND (Hide) ---
            "styles.plot_0.display": 0,        // Try to turn off
            "styles.plot_0.transparency": 100, // Force invisible
            "styles.plot_0.linewidth": 0,

            // Upper Band -> DARK YELLOW & VISIBLE
            "styles.plot_1.display": 1,           // 1 = Line
            "styles.plot_1.color": "#F9A825",     // Dark Yellow / Gold Hex Code
            "styles.plot_1.linewidth": 2,

            // --- LOWER BAND (Hide) ---
            "styles.plot_2.display": 0,
            "styles.plot_2.transparency": 100, // Force invisible
            "styles.plot_2.linewidth": 0,

            // Background Fill -> HIDE
            // This removes the shaded area between the bands
            "styles.plots_bg.display": 0
          });

          // --- RSI (Relative Strength Index) ---
          // Inputs: [Length (14)]
          // forceOverlay is 'false' so it appears in a separate pane below
          chart.createStudy('Relative Strength Index', false, false, [14]);

          // --- VWAP ---
          // --- 1. VWAP: White ---
          chart.createStudy('VWAP', false, false, [], {
            "styles.plot_0.color": "#FFFFFF",     // Set color to White
            "styles.plot_0.linewidth": 2          // Optional: Make it slightly thicker
          });
          // --- MACD (New Addition) ---
          // Inputs: [Fast Length (12), Slow Length (26), Source ("close"), Signal Smoothing (9)]
          chart.createStudy('MACD', false, false, [12, 26, "close", 9], {
            // Histogram -> RED
            "styles.plot_0.palettes.palette_0.colors.0.color": "#00C853",
            "styles.plot_0.palettes.palette_0.colors.1.color": "#00C853",

            // Map Negative (Growing & Shrinking) to RED
            "styles.plot_0.palettes.palette_0.colors.2.color": "#D50000",
            "styles.plot_0.palettes.palette_0.colors.3.color": "#D50000",
            "styles.plot_0.linewidth": 4, // 4 usually creates the 'Columns' look

            // MACD Line -> GREEN
            "styles.plot_1.color": "#00FF00",
            "styles.plot_1.linewidth": 2,

            // Signal Line -> YELLOW
            "styles.plot_2.₹color": "#FFFF00",
            "styles.plot_2.linewidth": 2
          });
        }

      });
    });
  }

}
